<mat-form-field class="w-100" appearance="outline">
     <mat-label>{{ label }}</mat-label>

     <input
             type="text"
             matInput
             [placeholder]="placeholder"
             [formControl]="trabajadorSearchCtrl"
             [matAutocomplete]="auto"
     />

     <mat-icon matSuffix *ngIf="isSearching">
          <mat-spinner diameter="20"></mat-spinner>
     </mat-icon>
     <button
             *ngIf="!isSearching"
             mat-icon-button
             matSuffix
             type="button"
             (click)="hasSelection() ? clearSelection() : null"
             [disabled]="isSearching"
     >
          <mat-icon>{{ hasSelection() ? 'clear' : 'search' }}</mat-icon>
     </button>

     <mat-autocomplete
         #auto="matAutocomplete"
         [displayWith]="displayTrabajador.bind(this)"
         (optionSelected)="onTrabajadorSelected($event)"
     >
          <mat-option *ngIf="isSearching" disabled>
               Cargando...
          </mat-option>

          <mat-option
                  *ngFor="let trabajador of filteredTrabajadores | async"
                  [value]="trabajador"
          >
               {{ displayTrabajador(trabajador) }}
          </mat-option>
     </mat-autocomplete>
</mat-form-field>
